import { render, staticRenderFns } from "./Snippet_Small.vue?vue&type=template&id=5697fcde&"
import script from "./Snippet_Small.vue?vue&type=script&lang=js&"
export * from "./Snippet_Small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports